import { TabPlane } from "../../UI/components/TabPlane/TabPlane";
import { useRouter } from "next/router";
import plansImpoter from "../../assets/newPlansImpoter.json";
import plansExport from "../../assets/plansExport.json";
import plansBoth from "../../assets/newPlansBoth.json";

import newPlansExporter from "../../assets/newPlansExport.json";
import newPlansImpoter from "../../assets/newPlansImpoter.json";
import newPlansBoth from "../../assets/newPlansBoth.json";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Divider } from "@mui/material";

import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import CoimexNewTable from "../../UI/components/Table/NewPricingTable";
import CoimexPriceCardMobile from "../../UI/components/Card/PricingCardMobile";
import { CoimexButton } from "../../UI/components/Card/Button";

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../UI/components/Card/Card";
import { TabContext } from "@mui/lab";
import LinkedInTag from "react-linkedin-insight";
import { GApageView, initGA, linkedin_partner_id } from "../_document";
import { hotjar } from "react-hotjar";
export default function Pricing(props) {
  const [plans, setPlans] = useState(newPlansBoth);
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState("1");
  const handleChange = (newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    initGA();
    GApageView("price Page");
    LinkedInTag.init(linkedin_partner_id);
    if (hotjar.initialized()) {
      hotjar.stateChange("/pricing");
    }
  }, []);
  useEffect(() => {
    if (router.query.package === "importer") {
      setPlans(newPlansImpoter);
    } else if (router.query.package === "exporter") {
      setPlans(newPlansExporter);
    } else {
      setPlans(plansBoth);
    }
  }, [router.query.package]);
  let reverseArray = [...plans.data].reverse();

  return (
    <>
      <Head>
        <title>{t("meta.7")}</title>
        <meta name="description" content={t("meta.8")} />
        <meta name="keywords" content={t("meta.8")} />
        <meta itemProp="description" content={t("meta.8")} />
        <meta property="og:description" content={t("meta.8")} />
        <meta name="twitter:description" content={t("meta.8")} />
      </Head>
      <div
        className={`${
          router.query.package === "importer"
            ? "px-4 md:px-24"
            : "px-4 md:px-24"
        } w-full bg-PrimaryA min-h-screen m-auto flex items-center flex-col`}
      >
        <h2 className="text-[30px] md:text-[52px] font-semibold font-Montserrat mt-16 text-fontColorB">
          {t("NewPrice.0")}
        </h2>

        <p className=" text-base text-fontColorc w-full md:w-[642px] text-center font-montserrat">
          {t("NewPrice.57")}
        </p>
        <button
          rel="noopener noreferrer"
          className="bg-fontColorB md:bg-[#FFFBFE] text-[#FFFBFE] md:text-fontColorB text-center font-MontserratSemiBold text-base h-[42px] rounded-[30px] mt-6 border border-fontColorB w-full md:w-[360px] border-b-[1px] border-b-[#38466D]"
          style={{
            fontWeight: 800,
            fontStyle: "normal",
          }}
          onClick={() => {
            window.open("https://wa.me/905324479299", "_blank");
          }}
        >
          {t("NewPrice.2")}
        </button>
        <div className={` w-full mx-auto py-16 space-y-16`}>
          {/* Pricing Tiers */}
          <section>
            <div
              className={`grid md:gap-1 gap-4 w-full ${
                router.query.package === "importer"
                  ? "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
                  : "grid-cols-1 md:grid-cols-3 "
              }`}
            >
              {reverseArray
                .filter((plan) => plan.duration.type === "Annually")
                .map((plan, index) => (
                  <Card
                    key={index}
                    className={`
          flex flex-col justify-between bg-[#F4EFF4]
          px-4 py-2 md:px-6 md:py-4 lg:${
            router.query.package === "importer" ? "px-4" : "px-32"
          }
          min-h-full md:shadow-lg shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] "
        `}
                  >
                    <CardHeader
                      className={`py-4 md:py-6 ${
                        router.query.package === "importer"
                          ? "px-4 md:px-6"
                          : "px-4 md:px-6 py-4 md:py-6"
                      }`}
                    >
                      <CardTitle className="text-fontColorB text-[28px] leading-6 mb-1 text-left font-MontserratSemiBold font-bold">
                        {plan.type}
                      </CardTitle>
                      <div className="space-y-1 text-left leading-6">
                        <p className="text-base text-nowrap ">
                          {plan.commonTag}{" "}
                          <span className="font-semibold">{plan.bestFor}</span>
                          {/* <span className="font-normal hidden md:inline">
                            {" "}
                            {plan.description2}
                          </span> */}
                        </p>
                        <p className="text-base text-muted-foreground md:inline">
                          {/* <span className="font-normal md:hidden inline">
                            {plan.description2}
                          </span>{" "} */}
                          {plan.description}
                        </p>
                      </div>
                    </CardHeader>
                    <Divider
                      className="ml-4 md:ml-6 mb-[18px] md:mb-0 w-full md:w-[237px]"
                      sx={{ borderColor: "#38466D" }}
                    />
                    <CardContent className="flex-grow px-4 md:px-6 py-4 md:py-6">
                      <ul className="space-y-3 md:space-y-4 flex flex-col items-start self-stretch">
                        {plan.quota &&
                          Object.keys(plan.quota).length > 0 &&
                          Object.keys(plan.quota).map((key) => {
                            const item = plan.quota[key];
                            let text = "";
                            let icon = null;
                            let isBold = false;

                            // Skip rendering if promptPayAssurance is false
                            if (key === "promptPayAssurance" && !item) {
                              return null;
                            }

                            if (key === "expansionFund" && item === false) {
                              return null;
                            }

                            switch (key) {
                              case "tradeGuarantee":
                                text = `${item} ${
                                  router.query.package === "importer"
                                    ? item < 2
                                      ? t("NewPrice.60")
                                      : t("NewPrice.61")
                                    : item < 2
                                    ? t("NewPrice.38")
                                    : t("NewPrice.59")
                                }`;
                                icon = (
                                  <SvgGroup className="text-primary flex-shrink-0" />
                                );
                                isBold = true;
                                break;
                              case "productCategory":
                                text = item;
                                icon = <SvgTck className="flex-shrink-0" />;
                                break;
                              case "escrowSafePaymentFees":
                                text = `${item} ${t("NewPrice.42")}`;
                                icon = <SvgTck className="flex-shrink-0" />;
                                break;
                              case "promptPayAssurance":
                                text = t("NewPrice.43");
                                icon = <SvgTck className="flex-shrink-0" />;
                                break;
                              case "expansionFund":
                                text = t("NewPrice.66");
                                icon = <SvgTck className="flex-shrink-0" />;
                                break;
                              default:
                                return null;
                            }

                            return (
                              <li key={key} className="flex gap-3">
                                {icon}
                                <div className="flex-1">
                                  <span
                                    className={`text-base ${
                                      isBold ? "font-bold" : ""
                                    }`}
                                  >
                                    {t(
                                      `NewPrice.${
                                        key === "tradeGuarantee"
                                          ? "20"
                                          : key === "productCategory"
                                          ? "21"
                                          : key === "escrowSafePaymentFees"
                                          ? "41"
                                          : key === "promptPayAssurance"
                                          ? "43"
                                          : key === "expansionFund"
                                          ? "67"
                                          : ""
                                      }`
                                    )}
                                  </span>{" "}
                                  {key !== "promptPayAssurance" && (
                                    <span className="text-base">{text}</span>
                                  )}
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </CardContent>
                    <CardFooter className="py-4 md:py-6 px-4 md:px-6 flex flex-col gap-4 md:gap-6 text-left">
                      <div className="space-y-2">
                        <p className="text-base text-fontColorB font-MontserratBold font-bold">
                          ${plan.price} {t("NewPrice.33")}
                        </p>

                        {plan.type !== "Freemium" && (
                          <>
                            <p className="text-base text-[#000] leading-[20px] font-MontserratBold font-bold my-2">
                              Or
                            </p>
                            <div className="flex gap-2">
                              <CoimexIcon />
                              <p className="leading-[20px] text-base font-bold text-fontColorB">
                                {t("NewPrice.44")}{" "}
                                <a className="font-bold">{t("NewPrice.11")}</a>{" "}
                                {t("NewPrice.58")}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <CoimexButton
                        className="bg-[#38466D] hover:bg-[#1f2a4b] text-[#FFFBFE] w-full"
                        size="lg"
                        onClick={() =>
                          router.push(
                            `https://app.coimex.co/#/auth/register/importer/${plan.id}`
                          )
                        }
                      >
                        {plan.type === "Freemium"
                          ? t("NewPrice.62")
                          : t("NewPrice.12")}
                      </CoimexButton>
                    </CardFooter>
                  </Card>
                ))}
            </div>

            {/* How trade Guarantee works */}
            <div className="bg-[#D7DAE3] p-4 sm:p-8 mt-4 rounded-[8px]">
              <div className="flex items-start gap-2 mb-4">
                <SvgGroup className="h-5 w-5 text-black flex-shrink-0 mt-0.5" />
                <div className="text-[20px] sm:text-[24px]">
                  <span className="text-[#4A5568]">{t("NewPrice.52")}</span>
                  <span className="font-bold text-black">
                    {" "}
                    {t("NewPrice.20")}
                  </span>
                  <span className="text-[#4A5568]"> {t("NewPrice.53")}</span>
                </div>
              </div>
              <p className="text-base text-black leading-relaxed">
                {t("NewPrice.54")}{" "}
                {router.query.package === "importer"
                  ? t("NewPrice.61")
                  : t("NewPrice.59")}{" "}
                {t("NewPrice.65")}
              </p>
              <p className="text-base text-black leading-relaxed mt-2">
                {t("NewPrice.55")}
              </p>
              <p className="text-black"> {t("NewPrice.68")}</p>
            </div>
          </section>
        </div>
        <div className="  w-full m-auto  flex items-center flex-col ">
          <h2 className="text-[30px] md:text-[52px] font-semibold font-Montserrat text-fontColorB">
            {t("NewPrice.56")}
          </h2>

          <p className=" text-base text-fontColorc w-full md:w-[642px] text-center font-montserrat">
            {t("NewPrice.69")}
          </p>
        </div>

        <div
          className={`${
            router.query.package === "importer" ? "w-[100%] " : "w-[100%] "
          } sm:bg-fontColorSurface mb-8  mt-8 md:my-[50px] rounded-2xl  sm:py-4 md:flex flex-col items-center `}
        >
          <CoimexNewTable
            onClick={(e) =>
              router.push(
                `https://app.coimex.co/#/auth/register/exporter/${e.id}`
              )
            }
            data={[...plans.data].reverse()}
            value={value === "1" ? "Annually" : "Biannually"}
          />
          <CoimexPriceCardMobile
            onClick={(e) =>
              router.push(
                `https://app.coimex.co/#/auth/register/exporter/${e.id}`
              )
            }
            data={[...plans.data].reverse()}
            value={value === "1" ? "Annually" : "Biannually"}
          />
        </div>
        <div className="sm:bg-fontColorSurface hidden bg-white md:my-[50px] w-[90%] rounded-2xl  sm:px-10  sm:py-4  flex-col items-center ">
          <TabPlane data={[...plans.data].reverse()} />
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

const SvgTck = () => (
  <svg
    className="m-auto"
    width="19"
    height="12"
    viewBox="0 0 19 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3749 0.839371C18.534 0.95786 18.6295 1.12358 18.6405 1.3001C18.6514 1.47662 18.5768 1.64949 18.4332 1.7807L7.63258 11.6214L1.10176 6.48204C0.955117 6.35848 0.872417 6.1928 0.871109 6.01995C0.869802 5.84709 0.949988 5.68057 1.09475 5.55552C1.23952 5.43047 1.43754 5.35666 1.64705 5.34967C1.85656 5.34267 2.06117 5.40304 2.21773 5.51804L7.54686 9.71137L17.2339 0.886704C17.3052 0.821759 17.3913 0.769031 17.4873 0.731535C17.5834 0.694038 17.6874 0.672509 17.7935 0.668175C17.8996 0.663841 18.0057 0.676788 18.1058 0.706277C18.2058 0.735767 18.2978 0.781219 18.3766 0.840037L18.3749 0.839371Z"
      fill="#38466D"
      stroke="#38466D"
      strokeWidth="0.5"
    />
  </svg>
);

const SvgNon = () => (
  <svg
    className="m-auto"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75294 6.00003L12.0528 10.3692M1.45312 10.3692L6.75294 6.00003L1.45312 10.3692ZM12.0528 1.63086L6.75193 6.00003L12.0528 1.63086ZM6.75193 6.00003L1.45312 1.63086L6.75193 6.00003Z"
      stroke="#38466D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgGroup = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="26"
    viewBox="0 0 22 26"
    fill="none"
  >
    <path
      d="M11.0013 1.00012L11.3946 0.0801156C11.2703 0.0269322 11.1365 -0.000488281 11.0013 -0.000488281C10.8661 -0.000488281 10.7323 0.0269322 10.608 0.0801156L11.0013 1.00012ZM11.0013 25.0001L10.5053 25.8681C10.6564 25.9544 10.8273 25.9998 11.0013 25.9998C11.1753 25.9998 11.3462 25.9544 11.4973 25.8681L11.0013 25.0001ZM10.6066 0.0814492L2.08397 3.73345L2.86797 5.57345L11.3933 1.92012L10.6066 0.0814492ZM0.667969 5.87878V15.0254H2.66797V5.87878H0.667969ZM5.20264 22.8388L10.5053 25.8681L11.4973 24.1321L6.19464 21.1014L5.20264 22.8388ZM11.4973 25.8681L16.8 22.8388L15.808 21.1014L10.5053 24.1321L11.4973 25.8681ZM21.3346 15.0241V5.88012H19.3346V15.0268L21.3346 15.0241ZM19.9213 3.73478L11.3946 0.0814492L10.608 1.91878L19.1333 5.57345L19.9213 3.73478ZM21.3346 5.88012C21.3346 4.94678 20.7786 4.10278 19.9213 3.73478L19.1333 5.57345C19.1932 5.59927 19.2442 5.64209 19.2799 5.69659C19.3157 5.7511 19.3347 5.81491 19.3346 5.88012H21.3346ZM16.8 22.8388C18.1774 22.0517 19.3223 20.9144 20.1186 19.5423C20.915 18.1702 21.3345 16.6119 21.3346 15.0254H19.3346C19.3344 16.2592 19.0081 17.4709 18.3887 18.5379C17.7694 19.6049 16.8791 20.4893 15.808 21.1014L16.8 22.8388ZM0.667969 15.0254C0.668111 16.6119 1.08761 18.1702 1.88396 19.5423C2.6803 20.9144 3.8252 22.0517 5.20264 22.8388L6.19464 21.1014C5.12331 20.4892 4.23286 19.6046 3.61353 18.5373C2.9942 17.4701 2.668 16.2581 2.66797 15.0241L0.667969 15.0254ZM2.0813 3.73345C1.66184 3.91341 1.30438 4.21245 1.05317 4.59354C0.801955 4.97462 0.668028 5.42235 0.667969 5.87878H2.66797C2.66797 5.74545 2.74797 5.62412 2.87064 5.57078L2.0813 3.73345Z"
      fill="#38466D"
    />
    <path
      d="M15 10.3335L9.66667 15.6668L7 13.0002"
      stroke="#38466D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CoimexIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16888 23.3069C5.16888 23.3069 4.01282 22.7457 3.54703 22.5381C3.07563 22.3248 2.64913 21.7468 2.57056 20.9836L0.0171318 3.55292C0.0171318 3.55292 -0.319584 1.47089 1.99253 1.90862L18.5309 8.42407L16.4881 9.96173L3.23838 4.78193C3.23838 4.78193 2.23945 4.45082 2.4471 5.51148C2.4471 5.51148 4.92757 22.9646 5.16888 23.3069Z"
      fill="#38466D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.6763 9.08067C22.6763 9.08067 22.7605 10.3602 22.811 10.8709C22.8615 11.3816 22.5697 12.0382 21.9524 12.4871L7.88331 23.6099C7.88331 23.6099 6.72726 24.5415 5.9023 23.5258C5.47018 22.9926 5.44774 22.5156 5.35795 21.8815L5.24571 21.1295L2.93359 5.11865L5.27938 6.1288L7.35018 20.2035C7.35018 20.2035 7.55782 21.2361 8.37716 20.529C8.37716 20.529 22.4968 9.45667 22.6763 9.08067Z"
      fill="#38466D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.37109 1.27997C1.37109 1.27997 2.43736 0.567256 2.85264 0.264212C3.26231 -0.0332202 3.98064 -0.111787 4.68213 0.196869L21.4001 6.7516C21.4001 6.7516 22.5337 7.18933 22.4046 8.17703C22.298 8.98515 21.6638 9.41726 21.0802 9.87183L7.87532 20.2202L7.48248 17.7061L18.7176 8.92341C18.7176 8.92341 19.5088 8.22754 18.4875 7.8796C18.4875 7.8796 1.78638 1.2463 1.37109 1.27997Z"
      fill="#38466D"
    />
  </svg>
);
